import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { IpCheckService } from "../service/ipcheck.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DialogsService } from "@mango/core";

@Injectable({
  providedIn: 'root'
})
export class IPCheckGuard implements CanActivate {

  constructor(
    private ipCheckService: IpCheckService,
    private router: Router,
    protected dialogs: DialogsService
  ) {}

  canActivate(): Observable<boolean> {
    return this.ipCheckService.isAllowed().pipe(
      take(1),
      map(isAllowed => {
        if (!isAllowed) {
            this.dialogs.alert("Inloggen niet toegestaan!", "Inloggen is alleen toegestaan vanuit het interne netwerk.", "announcement")
            this.router.navigate(['/login']);
            return false;
        }

        return true;
      }),
      catchError(() => {
        // bij fout: veiligste optie = blokkeren
        this.dialogs.alert("Inloggen niet toegestaan!", "Inloggen is alleen toegestaan vanuit het interne netwerk.", "announcement")
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}